document.addEventListener('DOMContentLoaded', function () {

  const interval = setInterval(() => {
    const yotpoContainer = document.querySelector(".yotpo.bottomLine.yotpo-small");
    if (yotpoContainer) {
      const scrollToReviews = function () {
        const yotpoReviewsSection = document.getElementById("yotpo-reviews-main-widget");
        if (yotpoReviewsSection) {
          yotpoReviewsSection.scrollIntoView({ behavior: 'smooth' });
        }
      };

      // Asignas el event listener
      yotpoContainer.addEventListener('click', scrollToReviews);

      // Yotpo renders this widget as a plain, non-interactive div. It functions as a
      // link to the reviews section, so it needs link semantics and keyboard support.
      const yotpoLink = yotpoContainer.querySelector(".star-clickable");
      if (yotpoLink) {
        const ratingText = yotpoContainer.querySelector(".yotpo-stars .sr-only");
        const reviewsCountLink = yotpoContainer.querySelector("a[aria-label]");
        const label = [ratingText, reviewsCountLink]
          .map((el) => el && el.textContent.trim())
          .filter(Boolean)
          .join(', ');

        yotpoLink.setAttribute('role', 'link');
        yotpoLink.setAttribute('tabindex', '0');
        if (label) {
          yotpoLink.setAttribute('aria-label', label);
        }

        yotpoLink.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            scrollToReviews();
          }
        });
      }

      clearInterval(interval);
    }
  }, 2000);

});
